import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import StepInput from "./StepInput";
import StepReview from "./StepReview";
import StepBackTest from "./StepBackTest";
import Stepper from "../../../components/Stepper/Stepper";
import "./new-pricing.style.scss";
import { convertFormToPayload, DATE_FORMAT } from "./helper";
import * as Http from "../../../http";
import moment from "moment";

function getFormValue(props) {
  let formValues = {};
  const pricingInfo = (props.location && props.location.pricingInfo) || null;
  if (pricingInfo && pricingInfo.customer_info) {
    formValues = { ...formValues, ...pricingInfo.customer_info };
  }
  if (pricingInfo && pricingInfo.facility_info) {
    formValues = { ...formValues, ...pricingInfo.facility_info };
  }
  return formValues;
}

function getBacktestData(props) {
  let backTestData = {};
  const pricingInfo = (props.location && props.location.pricingInfo) || null;
  if (pricingInfo && pricingInfo.result) {
    backTestData = { ...backTestData, ...pricingInfo.result };
  }
  return backTestData;
}

class PricingInfo extends Component {
  state = {
    step: 2,
    formValues: getFormValue(this.props),
    backTestData: getBacktestData(this.props),
  };

  handleNextToBackTest = () => {
    this.setState({ step: 3 });
  };

  renderStep = () => {
    const pricingInfo = this.props.location.pricingInfo || {};
    const type = pricingInfo.customer_type
      ? `${pricingInfo.customer_type}`.toLowerCase()
      : "retail";
    switch (this.state.step) {
      case 2:
        return (
          <StepReview
            backTestData={this.state.backTestData}
            type={type}
            formValues={this.state.formValues || {}}
            onSubmit={() => {
              this.handleNextToBackTest();
            }}
            onPrev={() => {
              this.setState({ step: 1 });
            }}
          />
        );
      case 3:
        return (
          <StepBackTest
            backTestData={this.state.backTestData}
            onSubmit={() => {
              this.props.history.push("/pricing/processing");
            }}
            onPrev={() => {
              this.setState({ step: 2 });
            }}
          />
        );
      default:
        return null;
    }
  };
  render() {
    const pricingInfo = this.props.location.pricingInfo || {};
    const type = pricingInfo.customer_type
      ? `${pricingInfo.customer_type}`.toLowerCase()
      : "retail";
    const customerName =
      pricingInfo && pricingInfo.customer_info
        ? type === "retail"
          ? pricingInfo.customer_info.name
          : pricingInfo.customer_info.customer_name
        : "";
    const typeName =
      type === "retail" ? "Retail Customer" : "Corporate Customer";
    return (
      true && (
        <div className="new-container">
          <div className="header">
            <h4 className="title">PROCESSING</h4>
          </div>
          <div className="new-pricing-container">
            <Stepper
              activeStep={this.state.step}
              steps={[
                {
                  title: "Step 1",
                  description: "Input customer's information",
                },
                {
                  title: "Step 2",
                  description: "Pricing Estimation",
                },
                {
                  title: "Step 3",
                  description: "Back Test",
                },
              ]}
            />
            <div className="head">
              <p className="cus-name">
                {customerName} <span className="type-name">{typeName}</span>
              </p>
              <p className="process-date">
                Process date:{" "}
                <span className="process-date_date">
                  {moment().format(DATE_FORMAT)}
                </span>
              </p>
            </div>

            <div>{this.renderStep()}</div>
          </div>
        </div>
      )
    );
  }
}

export default withRouter(PricingInfo);



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/PricingInfo.js